module.exports = __webpack_public_path__ + "img/check-circle.6731b28b.svg";